import React, { useEffect } from "react";
import { useMsal } from "@azure/msal-react";
import { EventType, InteractionRequiredAuthError } from "@azure/msal-browser";

export default function MsalEventHandler({ children }) {
  const { instance } = useMsal();

  useEffect(() => {
    // Sätt active account om det saknas (vanlig orsak till konstiga silent-problem över tid)
    if (!instance.getActiveAccount()) {
      const all = instance.getAllAccounts();
      if (all.length > 0) instance.setActiveAccount(all[0]);
    }

    const cbId = instance.addEventCallback((event) => {
      // Vid login: sätt active account
      if (event.eventType === EventType.LOGIN_SUCCESS && event.payload?.account) {
        instance.setActiveAccount(event.payload.account);
      }

      // Silent token-fel som kräver interaktion => redirect till login
      if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
        const err = event.error;

        if (err instanceof InteractionRequiredAuthError) {
          console.warn("MSAL: interaction required – redirecting to login");
        }
      }
    });

    return () => {
      if (cbId) instance.removeEventCallback(cbId);
    };
  }, [instance]);

  return <>{children}</>;
}
